<template>
  <div>
    <div class="page">
      <div
        v-if="getModuleConfig('staff_bind_success_page.form_title')"
        class="page__title"
      >
        {{ getModuleConfig("staff_bind_success_page.form_title") }}
      </div>
      <div v-if="getModuleConfig('staff_bind_success_page.form_desc')" class="page__desc">
        {{ getModuleConfig("staff_bind_success_page.form_desc") }}
      </div>
      <div
        v-if="getModuleConfig('staff_bind_success_page.content')"
        v-html="getModuleConfig('staff_bind_success_page.content')"
      ></div>
      <img
        v-for="image in contentImages"
        :src="image.image_url"
        :key="image.order"
        class="w-100"
      />
      <div
        v-if="getModuleConfig('staff_bind_success_page.content_url')"
        v-html="getModuleConfig('staff_bind_success_page.content_url')"
      ></div>
    </div>

    <div class="page__button s-space-y-4">
      <MemberButton
        :button-text="getModuleConfig('staff_bind_success_page.button_text')"
        :button-url="getModuleConfig('staff_bind_success_page.button_url')"
        :type="getModuleConfig('staff_bind_success_page.button_action')"
      >
      </MemberButton>
    </div>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import mixinStaff from "@/mixins/liff/staff";
import { mapGetters } from "vuex";
import liff from "@line/liff";

export default {
  mixins: [mixinStaff],
  components: {
    MemberButton,
  },

  data() {
    return {
      showLoading: false,
    };
  },

  async mounted() {
    await this.init();
    await this.sendLiffMessage();
  },

  computed: {
    ...mapGetters("liffGeneral", ["liffId"]),
    contentImages() {
      let contentImages = this.getModuleConfig("staff_bind_success_page.content_images") || []
      contentImages.sort((a, b) => a.order - b.order)
      return contentImages
    },
  },

  methods: {
    async sendLiffMessage() {
      if (this.getModuleConfig("staff_bind_success_page.send_messages.enable")) {
        await liff
          .sendMessages([
            {
              type: "text",
              text: this.getModuleConfig("staff_bind_success_page.send_messages.text"),
            },
          ])
          .then(() => {
            console.log("message sent");
          })
          .catch((err) => {
            console.log("error", err);
          });
        return;
      }
    },
    async init() {
      await liff
        .init({
          liffId: this.liffId,
        })
        .then(() => {
          if (!liff.isLoggedIn()) {
            liff.login({
              redirectUri: window.location.href,
            });
          }
        })
        .catch(() => {
          this.liffFailed();
        });
    },
  },
};
</script>
